import { HeaderComponent } from './header.component';
import { UserComponent } from './user/user.component';
import { AppLauncherComponent } from './app-launcher/app-launcher.component';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';

import { LoaderService } from './loader/loader.service';
import { LoaderInterceptor } from './loader/loader.interceptor';
import { OverlayModule } from '@angular/cdk/overlay';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserPreferenceDialogComponent } from './user-preference-dialog/user-preference-dialog.component';
import { AboutDialogComponent } from './about-dialog/about-dialog.component';
import { UserManualDirective } from '../shared/user-manual/user-manual.directive';
import { RouterLink } from '@angular/router';

const loaderProviders = [
  LoaderService,
  {
    provide: HTTP_INTERCEPTORS,
    useClass: LoaderInterceptor,
    multi: true,
  },
];

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatIconModule,
    MatMenuModule,
    MatToolbarModule,
    MatTooltipModule,
    MatCheckboxModule,
    MatProgressBarModule,
    BrowserAnimationsModule,
    A11yModule,
    OverlayModule,
    RouterModule,
    UserManualDirective,
    RouterLink,
  ],
  declarations: [HeaderComponent, UserComponent, UserPreferenceDialogComponent, AboutDialogComponent, AppLauncherComponent],
  providers: loaderProviders,
  exports: [HeaderComponent, AppLauncherComponent],
})
export class HeaderModule {}
